/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-template */
/* eslint-disable no-var */
import { getPartnerAccessToken } from '@leagueplatform/sso-util';

export async function getAccessToken(
  url: string,
  partnerToken: string | null,
  apiType?: string,
  ubk?: string,
) {
  let formType = '';
  if (apiType === 'forms') {
    const urlArr = url.split('=');
    const [, , urlP3] = urlArr;
    formType = urlP3;
  }
  // let token = '';
  // token = await getPartnerAccessToken('highmark');
  const requestOptions = {
    method: 'GET',
    headers: new Headers({
      Accept: 'application/json',
      Authorization: `Bearer ${partnerToken}`,
      ...(ubk && { brandUbk: ubk }),
    }),
  };
  try {
    return await fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => {
        const resultData = {
          ...data,
          type: formType,
        };
        return resultData;
      });
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}

export const getPartnerToken = async () => {
  try {
    const partnerAccessToken = await getPartnerAccessToken('highmark');
    return { success: true, token: partnerAccessToken };
  } catch (error) {
    return { success: false, errMsg: error };
  }
};

function parseJwt(token: string) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  // eslint-disable-next-line prefer-arrow-callback
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      // eslint-disable-next-line func-names
      .map(function (c) {
        return '%' + `00${c.charCodeAt(0).toString(16)}`.slice(-2);
      })
      .join(''),
  );
  return JSON.parse(jsonPayload);
}

export async function getClientAccessToken(url: string, token: string) {
  // let token = '';
  // token = await getPartnerAccessToken('highmark');
  const decryptToken = parseJwt(token);
  return `${url}?clientId=${decryptToken.client}`;
}
